import type { FC, SVGProps } from 'react';

export const PlusCircleIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_plus_circle)">
        <path
          fill="currentColor"
          d="M11.2856 7.42941H8.57129V4.71512C8.57129 4.63655 8.50701 4.57227 8.42843 4.57227H7.57129C7.49272 4.57227 7.42843 4.63655 7.42843 4.71512V7.42941H4.71415C4.63558 7.42941 4.57129 7.4937 4.57129 7.57227V8.42941C4.57129 8.50798 4.63558 8.57227 4.71415 8.57227H7.42843V11.2866C7.42843 11.3651 7.49272 11.4294 7.57129 11.4294H8.42843C8.50701 11.4294 8.57129 11.3651 8.57129 11.2866V8.57227H11.2856C11.3641 8.57227 11.4284 8.50798 11.4284 8.42941V7.57227C11.4284 7.4937 11.3641 7.42941 11.2856 7.42941Z"
        />
        <path
          fill="currentColor"
          d="M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_plus_circle">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
